// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const luhn: GlobalValidator = createValidator("luhn", 119);

export default luhn;
export const compact = luhn.compact;
export const format = luhn.format;
export const validate = luhn.validate;
export const generate = (length = 16): string =>
  getBinding().luhnGenerate(length);
